import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import * as strings from "../../strings"
import Yup from "../../lib/Yup"
import { Formik, Form } from "formik"
import _ from "lodash"
import styles from "./styles.css"
import * as FormikComponents from "../FormikComponents"


const DEFAULT_EXPENSE = {
  expenseType: "",
  value: "",
  details: "",
  expenseDate: new Date(),
  receipt: null,
}


class CreateExpenseDialog extends Component {
  props: {
    onSubmit: ( mixed ) => any,
    onDelete: ( mixed ) => any,
    onCancel: ( mixed ) => any,
    onDocumentDownload: ( mixed ) => any,
    expense: any,
    visible: boolean,
    BillingPhaseEnum: mixed,
    edit: boolean,
    user: any,
  }

  downloadDocument = ( values ) => {
    if ( this.props.onDocumentDownload ) {
      this.props.onDocumentDownload( values )
    }
  }

  submitExpense = ( values, formik ) => {
    this.props.onSubmit( values )
    formik.resetForm()
  }

  cancel = formik => () => {
    this.props.onCancel( formik.values )
    formik.resetForm()
  }

  deleteExpense = formik => () => {
    this.props.onDelete( formik.values )
    formik.resetForm()
  }

  buildFormActions = formik => {
    let actions = [
      { label: strings.generalStrings.cancel, onClick: this.cancel( formik ) },
      { label: strings.generalStrings.keep, onClick: formik.submitForm },
    ]

    if ( this.props.onDelete ) {
      actions.unshift( {
        label: strings.generalStrings.delete,
        onClick: this.deleteExpense( formik ),
      } )
    }

    return actions
  }

  buildExpenseTypes = () => {
    const isFinance = _.get( this.props, "user.groups", [] )
      .find( group => group === "Finance" )

    let expenseTypeBuild = _.chain( this.props )
      .get( "expenses.expenseTypes", [] )

    if ( !isFinance ) {
      expenseTypeBuild = expenseTypeBuild.filter( { billingPhase: "OnGoing" } )
    }

    return expenseTypeBuild
      .sortBy( "name" )
      .map( et => ( {
        value: et.name,
        label: et.name,
      } ) )
      .value()
  }

  render () {
    const { edit } = this.props

    const expenseTypes = this.buildExpenseTypes()

    const expenseSchema = Yup.object().shape( {
      expenseType: Yup.string()
        .oneOf( expenseTypes.map( et => et.value ) )
        .required(),
      value: Yup
        .number()
        .positive()
        .required(),
      details: Yup
        .string()
        .nullable(),
      expenseDate: Yup
        .date()
        .nullable(),
      documentNumber: Yup
        .string()
        .nullable(),
      receipt: Yup
        .mixed()
        .nullable(),
    } )

    return (
      <Formik
        initialValues={this.props.expense || DEFAULT_EXPENSE}
        validationSchema={expenseSchema}
        onSubmit={this.submitExpense}
        enableReinitialize
      >
        { ( formik ) => (
          <Dialog
            actions={this.buildFormActions( formik )}
            active={this.props.visible}
            onEscKeyDown={this.cancel( formik )}
            onOverlayClick={this.cancel( formik )}
            type="small"
          >
            <Division title={edit ? strings.expenses.editExpense : strings.expenses.addExpense} />
            <Form>
              <FormikComponents.Dropdown
                label={strings.management.expenseType}
                name="expenseType"
                source={expenseTypes}
                auto={false}
              />
              <FormikComponents.Input
                label={strings.generalStrings.details}
                name="details"
              />
              <div className={styles.row}>
                <FormikComponents.Input
                  label={strings.generalStrings.value}
                  type="number"
                  step="0.01"
                  name="value"
                />
                <FormikComponents.DatePicker
                  label={strings.generalStrings.date}
                  name="expenseDate"
                />
              </div>
              <div className={styles.row}>
                <FormikComponents.Input
                  label={strings.generalStrings.documentNumber}
                  name="documentNumber"
                />
              </div>
              <FormikComponents.FilePicker
                label={strings.generalStrings.proofDocument}
                name="receipt"
                onFileClick={() => this.downloadDocument( formik.values )}
              />
            </Form>
          </Dialog>
        )}
      </Formik>
    )
  }
}

export default connect( store => _.pick( store, [ "expenses", "user" ] ) )( CreateExpenseDialog )



// WEBPACK FOOTER //
// ./src/components/DebtPhaseExpenses/ExpenseDialog.jsx